





















































import Vue from "vue";
import { OrderItem } from "../models/OrderItem";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => OrderItem[]
    },
    state: {
      type: String
    }
  },
  computed: {
    orderItems: {
      get(): OrderItem[] {
        return (this as any).value;
      },
      set(orderItems: OrderItem[]) {
        (this as any).$emit("input", orderItems);
      }
    },
    isInfoTable() {
      return (this as any).state === "INFO";
    },
    isRecoverTable() {
      return (this as any).state === "RECOVER";
    }
  },
  methods: {
    deleteProduct(index: number) {
      this.$emit("deleteProduct", index);
    }
  }
});
